// Contenido en español

export const ui = {
  logo: 'QUBO Car Tech',
  nav: [
    { label: 'Tecnología', href: '#tecnologia' },
    { label: 'Productos', href: '#productos' },
    { label: 'Sectores', href: '#sectores' },
    { label: 'Modelo', href: '#modelo' }
  ],
  contact: 'Contactar',
  languageNames: { en: 'English', es: 'Español' },
  hero: {
    imageAlt: 'Portal Qubo - Sistema de inspección vehicular',
    stats: [
      { value: '<60s', label: 'Inspección completa' },
      { value: '360°', label: 'Cobertura visual' },
      { value: 'Alta', label: 'Precisión IA' },
      { value: '24/7', label: 'Operación' }
    ]
  },
  valueProposition: {
    title: 'Propuesta de valor',
    subtitle: 'Transformamos la inspección vehicular en un proceso objetivo, rápido y escalable'
  },
  sectors: {
    title: 'Sectores',
    subtitle: 'Soluciones diseñadas para maximizar el retorno de inversión en cada sector',
    benefitsLabel: (count) => `${count} beneficios`,
    highlightLabel: 'ROI comprobado:',
    highlightText: 'Cada sector obtiene beneficios medibles desde el primer día de operación'
  },
  technology: {
    imageAlt: 'Portal Qubo - Tecnología de inspección',
    detectionTitle: '¿Qué detectamos?',
    detectionSubtitle: 'Nuestro sistema de inteligencia artificial identifica automáticamente más de 20 elementos diferentes del vehículo',
    detectionFooter: '+ Más capacidades agregándose continuamente con actualizaciones de IA',
    metrics: [
      { value: '4K', label: 'Resolución de cámaras' },
      { value: '12+', label: 'Puntos de captura' },
      { value: 'IA', label: 'Visión por computadora' },
      { value: 'EDGE', label: 'Arquitectura propia con procesamiento en tiempo real' }
    ]
  },
  products: {
    title: 'Productos',
    subtitle: 'Una solución tecnológica integral que combina hardware, software e inteligencia artificial',
    bottomLabel: 'Solución modular:',
    bottomText: 'Adquiere los componentes que necesitas y escala según tu operación'
  },
  scale: {
    imageAlt: 'Instalación industrial de múltiples portales Qubo',
    badgeTitle: 'Instalación Multi-Portal',
    badgeSubtitle: 'Operación en producción'
  },
  howItWorks: {
    title: '¿Cómo funciona?',
    subtitle: 'Un proceso simple y automatizado de cuatro pasos',
    flow: [
      { title: 'Vehículo', subtitle: 'Entrada' },
      { title: 'Captura', subtitle: 'Imágenes 360°' },
      { title: 'Análisis IA', subtitle: 'Procesamiento' },
      { title: 'Datos', subtitle: 'Reportes & APIs' }
    ]
  },
  competitiveAdvantages: {
    title: 'Ventajas competitivas',
    subtitle: 'Tecnología diseñada para escalar, innovar y liderar el mercado desde el día uno',
    bottomTitle: 'Tecnología lista para crecer globalmente',
    bottomText: 'Arquitectura modular, diseño robusto y capacidades de integración que permiten escalar a nuevos mercados sin reingeniería'
  },
  whyQubo: {
    beforeLabel: 'Antes',
    afterLabel: 'Con Qubo',
    bottomTitle: 'Transformación operativa, no solo tecnología',
    bottomText: 'Qubo no reemplaza un proceso manual con uno digital. Crea un ecosistema completo de datos que mejora cada decisión en tu operación vehicular.'
  },
  faq: {
    title: 'Preguntas frecuentes',
    subtitle: 'Todo lo que necesitas saber sobre Qubo',
    contactTitle: '¿Tienes más preguntas?',
    contactText: 'Nuestro equipo está listo para ayudarte a encontrar la solución perfecta para tu operación',
    contactCta: 'Contáctanos →'
  },
  contactForm: {
    title: 'Hablemos',
    subtitle: 'Contanos sobre tu operación y te ayudamos a encontrar la solución ideal',
    nameLabel: 'Nombre',
    namePlaceholder: 'Tu nombre',
    emailLabel: 'Email',
    emailPlaceholder: 'vos@empresa.com',
    messageLabel: 'Mensaje',
    messagePlaceholder: 'Contanos sobre tu flotilla, agencia u operación...',
    submit: 'Enviar mensaje',
    submitting: 'Enviando...',
    successMessage: '¡Mensaje enviado! Te vamos a responder pronto.',
    errorMessage: 'Algo salió mal. Intentá de nuevo o escribinos directamente.',
    emailSubject: 'Nuevo mensaje de contacto - Qubo Car Tech'
  },
  footer: {
    ctaTitle: 'Transforma tu operación vehicular',
    ctaSubtitle: 'Únete a las empresas que están revolucionando la inspección vehicular con tecnología de punta',
    ctaButton: 'Explorar tecnología',
    description: 'Infraestructura inteligente para la inspección vehicular. Transformando cada inspección en datos estructurados y accionables.',
    productsHeading: 'Productos',
    productLinks: ['Portal Qubo', 'Plataforma Qubo', 'Integraciones'],
    companyHeading: 'Empresa',
    companyLinks: ['Nosotros', 'Contacto', 'Blog'],
    rightsReserved: (year) => `© ${year} Qubo Car Tech. Todos los derechos reservados.`,
    legalLinks: ['Privacidad', 'Términos', 'Cookies']
  }
};

export const hero = {
  title: 'Infraestructura inteligente para la inspección vehicular',
  subtitle: 'Qubo transforma cada inspección en datos estructurados, auditables y accionables para empresas.',
  ctaPrimary: 'Explorar tecnología',
  ctaSecondary: null,
  heroImage: 'https://customer-assets.emergentagent.com/job_auto-scan-ai/artifacts/248osucc_33c92793-73f5-4e63-bfca-f5c6aa2480d6.png'
};

export const valuePropositions = [
  {
    id: 1,
    title: 'Inspecciones en segundos',
    description: 'Captura completa del vehículo en menos de 60 segundos, optimizando tiempos operativos.',
    icon: 'zap'
  },
  {
    id: 2,
    title: 'Detección objetiva con IA',
    description: 'Análisis automatizado que elimina errores humanos y garantiza resultados consistentes.',
    icon: 'cpu'
  },
  {
    id: 3,
    title: 'Historial estructurado',
    description: 'Cada inspección crea un registro permanente y auditable del estado del vehículo.',
    icon: 'database'
  },
  {
    id: 4,
    title: 'Mejora operativa',
    description: 'Datos accionables que permiten optimizar procesos y tomar mejores decisiones de negocio.',
    icon: 'trending-up'
  }
];

export const sectors = [
  {
    id: 1,
    title: 'Flotillas',
    icon: 'truck',
    benefits: [
      {
        title: 'Menores costes y mayor margen por vehículo',
        description: 'Detectamos daños a tiempo y evitamos reparaciones mayores.'
      },
      {
        title: 'Mantenimiento predictivo que reduce inactividad',
        description: 'Anticipamos fallos antes de afectar la operación.'
      },
      {
        title: 'Visibilidad total de la flota en tiempo real',
        description: 'Control centralizado del estado de todos los vehículos.'
      }
    ]
  },
  {
    id: 2,
    title: 'Distribuidores automotrices (agencias)',
    icon: 'store',
    benefits: [
      {
        title: 'Más ingresos en hojalatería y pintura',
        description: 'Detección automática de daños que genera ventas inmediatas.'
      },
      {
        title: 'Incremento en ingresos del taller de servicio',
        description: 'Identificación precisa de mantenimiento y reparaciones necesarias.'
      },
      {
        title: 'Aumento del ticket medio por cliente',
        description: 'Cada inspección se convierte en una oportunidad de ingreso adicional.'
      },
      {
        title: 'Registro automático de entradas y salidas de vehículos',
        description: 'Control total del inventario en tiempo real, sin procesos manuales.'
      },
      {
        title: 'Mayor conversión gracias a transparencia total',
        description: 'El cliente acepta más servicios al ver evidencia objetiva.'
      },
      {
        title: 'Incremento del valor en vehículos seminuevos',
        description: 'Historial verificable que aumenta confianza y precio de venta.'
      }
    ]
  },
  {
    id: 3,
    title: 'Aseguradoras',
    icon: 'shield-check',
    benefits: [
      {
        title: 'Reducción directa del fraude',
        description: 'Comparación con historial previo del vehículo.'
      },
      {
        title: 'Menores costes por gestión de siniestros',
        description: 'Procesos más rápidos y objetivos.'
      },
      {
        title: 'Mejor evaluación del riesgo basada en datos reales',
        description: 'Información precisa para decisiones más acertadas.'
      }
    ]
  },
  {
    id: 4,
    title: 'Empresas de alquiler',
    icon: 'key',
    benefits: [
      {
        title: 'Reducción de disputas y daños no reportados',
        description: 'Evidencia objetiva en cada entrega y devolución.'
      },
      {
        title: 'Mayor rentabilidad por vehículo',
        description: 'Menos pérdidas y mejor control operativo.'
      }
    ]
  },
  {
    id: 5,
    title: 'Aeropuertos',
    icon: 'plane',
    benefits: [
      {
        title: 'Inspección automática en entradas y salidas de rentadoras',
        description: 'Registro instantáneo del estado del vehículo en cada entrega y devolución.'
      },
      {
        title: 'Reducción de disputas con clientes en zonas de alto tráfico',
        description: 'Evidencia objetiva que elimina conflictos en operaciones de alquiler.'
      },
      {
        title: 'Mayor velocidad en el flujo de vehículos',
        description: 'Inspecciones en segundos que evitan cuellos de botella en horas pico.'
      },
      {
        title: 'Optimización operativa para empresas de alquiler',
        description: 'Procesos más eficientes en un entorno de alto volumen y exigencia.'
      },
      {
        title: 'Infraestructura preparada para operaciones 24/7',
        description: 'Escalable para miles de vehículos diarios sin fricción.'
      }
    ]
  },
  {
    id: 6,
    title: 'Sector público',
    icon: 'building',
    benefits: [
      {
        title: 'Transparencia total en el uso de vehículos',
        description: 'Registro verificable del estado y uso de cada unidad.'
      },
      {
        title: 'Reducción de mal uso y corrupción',
        description: 'Evidencia objetiva que limita abusos y uso indebido.'
      },
      {
        title: 'Optimización del gasto público en mantenimiento',
        description: 'Detección temprana que evita costes mayores.'
      },
      {
        title: 'Control centralizado de flotas',
        description: 'Supervisión en tiempo real desde una sola plataforma.'
      },
      {
        title: 'Trazabilidad completa para auditorías',
        description: 'Historial accesible que facilita revisiones y cumplimiento.'
      }
    ]
  }
];

export const technologyData = {
  title: 'De inspección a inteligencia',
  description: 'Qubo captura, analiza y estructura información vehicular para convertirla en decisiones estratégicas.',
  steps: [
    {
      id: 1,
      title: 'Captura',
      description: 'El vehículo atraviesa el portal mientras cámaras de alta resolución capturan imágenes desde todos los ángulos.'
    },
    {
      id: 2,
      title: 'Análisis',
      description: 'La inteligencia artificial procesa las imágenes e identifica automáticamente daños, componentes y estado general.'
    },
    {
      id: 3,
      title: 'Estructuración',
      description: 'Los hallazgos se convierten en datos estructurados, clasificados y geolocalizados en el vehículo.'
    },
    {
      id: 4,
      title: 'Acción',
      description: 'Los datos se integran a sistemas operativos, generando reportes, alertas y análisis predictivos.'
    }
  ],
  detectionCapabilities: [
    'Oxidaciones y corrosión',
    'Rayones y arañazos',
    'Abolladuras y deformaciones',
    'Golpes estructurales',
    'Manchas de pintura',
    'Suciedad y contaminantes',
    'Alineación de carrocería',
    'Presión de neumáticos',
    'Desgaste de neumáticos',
    'Grietas en parabrisas',
    'Estado de cristales',
    'Fugas de fluidos',
    'Condición de faros y luces',
    'Estado de molduras',
    'Daños en retrovisores',
    'Lectura de placas (OCR)',
    'Número VIN',
    'Marca y modelo de llantas',
    'Tapones de combustible'
  ],
  image: '/scanner.jpg'
};

export const products = [
  {
    id: 1,
    title: 'Portal Qubo',
    description: 'Sistema físico de inspección vehicular con hardware de última generación, cámaras de alta resolución y procesamiento en el edge.',
    features: [
      'Instalación modular',
      'Captura 360° en segundos',
      'Operación autónoma',
      'Mantenimiento mínimo'
    ],
    image: '/scanner.jpg',
    badge: 'Hardware',
    icon: 'box'
  },
  {
    id: 3,
    title: 'Plataforma Qubo',
    description: 'Software integral para visualizar, gestionar y analizar inspecciones. Accede a historiales completos, genera reportes personalizados y obtén insights operativos.',
    features: [
      'Dashboard en tiempo real',
      'Reportes personalizables',
      'Análisis predictivo',
      'APIs de integración'
    ],
    image: 'https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwzfHxzb2Z0d2FyZSUyMHBsYXRmb3JtJTIwZGFzaGJvYXJkJTIwaW50ZXJmYWNlfGVufDB8fHx8MTc3NjE4NDk5NXww&ixlib=rb-4.1.0&q=85',
    badge: 'Software',
    icon: 'monitor'
  },
  {
    id: 4,
    title: 'Integraciones',
    description: 'Conexión nativa con sistemas ERP, CRM, plataformas de gestión de flotillas y herramientas de terceros para automatizar flujos de trabajo.',
    features: [
      'APIs RESTful',
      'Webhooks en tiempo real',
      'Conectores pre-construidos',
      'Documentación completa'
    ],
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxkYXNoYm9hcmQlMjBhbmFseXRpY3MlMjBpbnRlZ3JhdGlvbiUyMHRlY2hub2xvZ3l8ZW58MHx8fHwxNzc2MTg0Nzg5fDA&ixlib=rb-4.1.0&q=85',
    badge: 'APIs',
    icon: 'plug'
  }
];

export const howItWorksSteps = [
  {
    id: 1,
    number: '01',
    title: 'Captura del vehículo',
    description: 'El conductor posiciona el vehículo en el portal. El sistema inicia automáticamente la captura fotográfica desde múltiples ángulos.'
  },
  {
    id: 2,
    number: '02',
    title: 'Análisis con IA',
    description: 'Algoritmos de visión por computadora procesan las imágenes, detectando daños, componentes, placas y características del vehículo.'
  },
  {
    id: 3,
    number: '03',
    title: 'Estructuración de datos',
    description: 'La información se organiza en formato estructurado: tipo de daño, severidad, ubicación, componente afectado y evidencia fotográfica.'
  },
  {
    id: 4,
    number: '04',
    title: 'Uso operativo',
    description: 'Los datos se integran a tus sistemas para generar reportes, cotizaciones, seguimiento de reparaciones o análisis de flota.'
  }
];

export const competitiveAdvantages = [
  {
    id: 1,
    title: 'Modelo modular desde el inicio',
    description: 'Arquitectura diseñada para escalar rápidamente con unidades adicionales sin reingeniería.'
  },
  {
    id: 2,
    title: 'Sistema de conexión inmediata',
    description: 'Instalación plug-and-play que permite despliegue en días, no en meses.'
  },
  {
    id: 3,
    title: 'Costos optimizados',
    description: 'Modelo económico eficiente que facilita escalabilidad sin comprometer calidad.'
  },
  {
    id: 4,
    title: 'Infraestructura + IA + Software',
    description: 'Solución integral que combina hardware, inteligencia artificial y plataforma en un solo sistema.'
  },
  {
    id: 5,
    title: 'Diseño robusto y tecnológico',
    description: 'Hardware de grado industrial con estética premium que inspira confianza.'
  },
  {
    id: 6,
    title: 'Escalabilidad global',
    description: 'Tecnología lista para operar en múltiples mercados y regulaciones desde etapas tempranas.'
  }
];

export const businessModel = {
  title: 'Modelo de negocio',
  subtitle: 'Tres capas de monetización integradas',
  layers: [
    {
      id: 1,
      title: 'Infraestructura',
      subtitle: 'Ingresos desde el despliegue',
      description: 'Nuestro sistema se comercializa mediante venta directa, permitiendo una adopción ágil y la generación de ingresos desde el inicio.',
      icon: 'box'
    },
    {
      id: 2,
      title: 'Software',
      subtitle: 'Ingresos recurrentes y control operativo',
      description: 'Acceso a la plataforma mediante un modelo de suscripción mensual que centraliza reportes, historial del vehículo y análisis en tiempo real, generando valor continuo para cada cliente.',
      icon: 'monitor'
    },
    {
      id: 3,
      title: 'Datos',
      subtitle: 'Escalabilidad y monetización',
      description: 'Cada inspección genera un historial vehicular verificable, creando una capa de datos con valor para aseguradoras, flotillas y fabricantes.',
      icon: 'database'
    }
  ],
  closingStatement: 'Un modelo que escala con cada interacción. Cada escaneo genera ingreso y construye un activo de datos.'
};

export const whyQuboData = {
  title: '¿Por qué Qubo?',
  subtitle: 'La diferencia entre una inspección manual y una transformación operativa',
  comparison: {
    before: {
      title: 'Inspección tradicional',
      items: [
        'Inspección manual propensa a errores humanos',
        'Resultados inconsistentes entre inspectores',
        'Proceso lento que genera cuellos de botella operativos',
        'Datos no estructurados y difíciles de analizar',
        'Sin trazabilidad ni historial verificable del vehículo',
        'Costos ocultos por daños no detectados a tiempo',
        'Imposible escalar sin aumentar personal',
        'Disputas frecuentes sin evidencia objetiva',
        'Pérdida de información en transiciones',
        'Sin capacidad de análisis predictivo'
      ]
    },
    after: {
      title: 'Con Qubo',
      items: [
        'Detección automática con alta precisión',
        'Resultados objetivos y consistentes siempre',
        'Inspección completa en menos de 60 segundos',
        'Datos estructurados listos para decisiones inmediatas',
        'Historial completo y auditable de cada vehículo',
        'ROI inmediato por prevención de costos mayores',
        'Escalabilidad sin límites operativos',
        'Evidencia fotográfica que elimina disputas',
        'Información centralizada y siempre accesible',
        'IA que anticipa problemas antes de que ocurran'
      ]
    }
  }
};

export const scaleData = {
  title: 'Diseñado para escalar',
  subtitle: null,
  description: 'Nuestros sistemas están diseñados para crecer con tu negocio. Desde una sola unidad hasta instalaciones de múltiples portales, la arquitectura modular de Qubo permite expansión sin interrupciones operativas.',
  image: 'https://customer-assets.emergentagent.com/job_auto-scan-ai/artifacts/248osucc_33c92793-73f5-4e63-bfca-f5c6aa2480d6.png',
  features: [
    {
      id: 1,
      title: 'Instalación modular',
      description: 'Comienza con una unidad y expande según la demanda'
    },
    {
      id: 2,
      title: 'Operación simultánea',
      description: 'Múltiples portales trabajando en paralelo para mayor throughput'
    },
    {
      id: 3,
      title: 'Gestión centralizada',
      description: 'Controla todas tus unidades desde una sola plataforma'
    },
    {
      id: 4,
      title: 'Despliegue rápido',
      description: 'Instalación y puesta en marcha en días, no meses'
    }
  ]
};

export const faqData = [
  {
    id: 1,
    question: '¿Cuánto tiempo toma una inspección completa?',
    answer: 'Una inspección completa del vehículo toma menos de 60 segundos. El vehículo simplemente atraviesa el portal mientras nuestras cámaras capturan imágenes desde todos los ángulos de forma automática.'
  },
  {
    id: 2,
    question: '¿Qué tan preciso es el sistema de detección?',
    answer: 'Nuestro sistema de inteligencia artificial cuenta con alta precisión en la detección de daños y anomalías. Además, cada inspección queda respaldada con evidencia fotográfica de alta resolución para garantizar objetividad.'
  },
  {
    id: 3,
    question: '¿Se requiere personal especializado para operar el sistema?',
    answer: 'No. El Portal Qubo está diseñado para operación autónoma. El sistema inicia automáticamente la captura cuando detecta el vehículo, procesa las imágenes y genera reportes sin intervención humana.'
  },
  {
    id: 4,
    question: '¿Cómo se integra con nuestros sistemas actuales?',
    answer: 'Qubo ofrece APIs RESTful y webhooks que permiten integración directa con sistemas ERP, CRM, plataformas de gestión de flotillas y otras herramientas empresariales. También ofrecemos conectores pre-construidos para las plataformas más comunes.'
  },
  {
    id: 5,
    question: '¿Qué sucede con los datos de las inspecciones?',
    answer: 'Todos los datos se almacenan de forma segura y estructurada en la Plataforma Qubo. Tienes acceso completo a historiales, reportes personalizados y análisis predictivos. Los datos son completamente tuyos y puedes exportarlos en cualquier momento.'
  },
  {
    id: 6,
    question: '¿Cuánto espacio se requiere para la instalación?',
    answer: 'El Portal Qubo estándar requiere aproximadamente 4-5 metros de largo por 3-4 metros de ancho. Para espacios más reducidos, ofrecemos el Portal Qubo Compact con una huella menor sin comprometer la calidad de captura.'
  },
  {
    id: 7,
    question: '¿El sistema funciona en exteriores?',
    answer: 'Sí, el Portal Qubo está diseñado para operación 24/7 tanto en interiores como en exteriores. El hardware es de grado industrial y está preparado para diferentes condiciones climáticas.'
  },
  {
    id: 8,
    question: '¿Cuál es el modelo de negocio?',
    answer: 'Compra directa del sistema más una suscripción mensual. Incluye acceso a la Plataforma Qubo, actualizaciones y soporte técnico.'
  }
];
